module.exports = __webpack_public_path__ + "static/img/1.9742da4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/1.png
// module id = YTAs
// module chunks = 0